import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ValidationCheckStatus } from '../password-checks/password-checks.component';

@Component({
  selector: 'ef-validation-check',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './validation-check.component.html',
})
@UntilDestroy()
export class EfValidationCheckComponent {
  public readonly status = input<ValidationCheckStatus>('idle');
}
